<template>
    <Dialog :visible="visible" @update:visible="v => $emit('update:visible', v)" modal header="تفاصيل المستبعدين"
        :style="{ width: '55vw' }" :breakpoints="{ '1199px': '80vw', '575px': '95vw' }">
        <p class="fw-semibold mb-3">عدد المستبعدين: {{ excluded.length }}</p>

        <div v-if="excluded.length > 5" class="mb-3">
            <input type="search" class="form-control" placeholder="ابحث بالاسم أو رقم الطالب..." v-model="search" />
        </div>

        <div class="es-table-wrap">
            <table class="table table-sm table-striped mb-0">
                <thead>
                    <tr>
                        <th>الطالب</th>
                        <th>رقم الطالب</th>
                        <th>نظام الدراسة</th>
                        <th>رقم ولي الأمر</th>
                        <th>سبب الاستبعاد</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="s in filtered" :key="s.student_id">
                        <td>{{ s.student_name }}</td>
                        <td>{{ s.student_number }}</td>
                        <td>{{ studyModeLabel(s.study_mode) }}</td>
                        <td dir="ltr">{{ s.parent_phone || '—' }}</td>
                        <td>{{ s.reason }}</td>
                    </tr>
                </tbody>
            </table>
            <p v-if="!filtered.length" class="text-muted text-center py-4 mb-0">
                {{ excluded.length ? 'لا توجد نتائج مطابقة للبحث.' : 'لا يوجد طلاب مستبعدون حالياً.' }}
            </p>
        </div>

        <template #footer>
            <button type="button" class="btn btn-secondary" @click="$emit('update:visible', false)">إغلاق</button>
        </template>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';

export default {
    name: 'ExcludedStudentsDialog',
    components: { Dialog },
    props: {
        visible: { type: Boolean, default: false },
        // Unified list from the backend resolver — online-excluded AND
        // no-parent-phone students together, each with its own 'reason'.
        // Same collection the summary card's count is derived from, so this
        // dialog can never show a different picture than the count implies.
        excluded: { type: Array, default: () => [] },
    },
    emits: ['update:visible'],
    data() {
        return { search: '' };
    },
    computed: {
        filtered() {
            const q = this.search.trim().toLowerCase();
            if (!q) return this.excluded;
            return this.excluded.filter(s =>
                String(s.student_name ?? '').toLowerCase().includes(q) ||
                String(s.student_number ?? '').toLowerCase().includes(q)
            );
        },
    },
    watch: {
        visible(v) { if (v) this.search = ''; },
    },
    methods: {
        studyModeLabel(mode) {
            return { offline: 'حضوري', hybrid: 'هجين', online: 'أونلاين' }[mode] ?? '—';
        },
    },
};
</script>

<style scoped>
.es-table-wrap {
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid #e9ecef;
    border-radius: 6px;
}
.es-table-wrap table thead th {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
}
</style>
